var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ips-login__wrapper"},[_c('div',{staticClass:"ips-login__container"},[_c('login-header'),_c('login-background',[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1)],1),_c('login-footer')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }